import {
  isAuthoritativeProjection,
  resolveComposerChooserProjection,
  resolveComposerUiProjection,
} from '../composer/composerUiProjectionSelector.js';

const firstTruthy = (...readers) => readers.reduce((result, read) => result || read(), undefined);
const everyTruthy = (...readers) => readers.reduce((result, read) => result && read(), true);

function resolveObject(value = null) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : null;
}

function normalizeText(value = '') {
  return String(value || '').trim();
}

export function resolveBackendChooserProjection(payload = {}) {
  return resolveComposerChooserProjection(resolveComposerUiProjection(payload));
}

export function resolveBackendChooserQuestion(payload = {}) {
  const chooserProjection = resolveBackendChooserProjection(payload);
  return resolveObject(chooserProjection?.question);
}

export function isBackendQuestionChooserVisible(payload = {}) {
  const chooserProjection = resolveBackendChooserProjection(payload);
  return (
    isAuthoritativeProjection(chooserProjection)
    && chooserProjection.visible === true
    && normalizeText(chooserProjection.kind) === 'question'
    && chooserProjection.requires_explicit_user_action === true
  );
}

export function buildChooserAuthorityFields(payload = {}, fallbackToken = '') {
  const chooserProjection = resolveBackendChooserProjection(payload);
  const authoritative = isAuthoritativeProjection(chooserProjection);
  const dismissToken = normalizeText(
    firstTruthy(() => (chooserProjection.dismiss_token), () => (chooserProjection.dismissToken), () => (fallbackToken)),
  );
  return {
    authoritySource: authoritative ? 'backend' : 'none',
    dismissible: everyTruthy(() => (authoritative), () => (chooserProjection.dismissible === true)),
    dismissToken: authoritative ? dismissToken : '',
    keepModeOnSubmit: everyTruthy(() => (authoritative), () => (firstTruthy(() => (chooserProjection.keep_mode_on_submit === true), () => (chooserProjection.keepModeOnSubmit === true)))),
  };
}
